<template>
  <div v-if="isUserLogin" class="workbench-app__root">
    <div class="workbench-app__content">
      <div class="workbench-app__header">
        <div class="title">选择应用</div>
        <div class="tip-label">基于该模板应用，您已拥有以下应用：</div>
        <div class="btn-create-app" @click="onCreateAppClick">创建新应用</div>
      </div>
      <div class="workbench-app__body">
        <w-scroll class="w-scroll-root">
          <div class="scroll-root">
            <workbench-app-item
              v-for="(app, index) in appList"
              :key="app.platform_id + '_' + app.third_app_id + '_' + index"
              :appData="app"
              @on-app-click="onAppClick"
            ></workbench-app-item>
          </div>
        </w-scroll>
      </div>
    </div>
  </div>

  <app-workspace
    v-if="isShowAppWorkspace"
    :isWorkBench="true"
    :appData="{ tpl_id, platform_id }"
    @on-app-workspace-dialog-closed="onAppWorkspaceClosed"
    @on-open-middle-page-workbench="onOpenMiddlePageWorkbench"
  ></app-workspace>
</template>

<script setup lang="ts">
import { usePUserStore } from '@/store';
import { apiGetAppListBy_tpl, IAppListBy_tplParams, RespApp } from '@vas2t-lowcode/api';
import { computed, defineAsyncComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { TMiddlePageOpenAppQuery } from '../middle-page-open-app/middle-page-open-app';
import { getToMiddlePageAppParams } from '../middle-page-open-app/middle-page-open-app.router';
// import { WScroll } from '@vas2t-lowcode/libs';

const workbenchAppItem = defineAsyncComponent(() => import('./workbench-app-item.vue'));
const wScroll = defineAsyncComponent(() => import('@vas2t-lowcode/libs/src/components/w-scroll/w-scroll.vue'));

/** 平台 id */
const platform_id = ref('');
/** 模板 id */
const tpl_id = ref('');

/** 请求app列表状态 */
const isLoadingAppList = ref(false);
/** app列表 */
const appList = ref<RespApp[]>([]);
/** app数量为空 */
// const isNoApp = computed(() => {
//   return !appList.value?.length;
// });

const userStore = usePUserStore();
const isUserLogin = computed(() => {
  return userStore.isLogin;
});

/** 设置app列表 */
const setAppList = () => {
  if (isLoadingAppList.value) {
    return;
  }

  isLoadingAppList.value = true;
  const params = { platform_id: platform_id.value, tpl_id: tpl_id.value } as IAppListBy_tplParams;

  // 定制超时时间 10秒 和 后端同步
  const requestOption = { timeout: 10000 } as any;

  return apiGetAppListBy_tpl(params, requestOption)
    .then(({ data }) => {
      appList.value = data;

      // 数据为空则自动创建应用
      if (!data?.length) {
        onCreateAppClick();
      }
    })
    .catch(() => {
      appList.value.splice(0);
    })
    .finally(() => {
      isLoadingAppList.value = false;
    });
};

const route = useRoute();
const initData = () => {
  platform_id.value = route.query.platform_id as string;
  tpl_id.value = route.query.tpl_id as string;
};

const router = useRouter();
const onAppClick = (data: RespApp) => {
  const { platform_id, team_id, third_app_id, third_ws_id } = data;
  const query = {
    page_type: 'open',
    platform_id,
    team_id,
    third_app_id,
    third_ws_id,
  } as TMiddlePageOpenAppQuery;
  const params = getToMiddlePageAppParams(query);
  router.push(params);
};

const onCreateAppClick = () => {
  // 创建新应用
  isShowAppWorkspace.value = true;
};

/** 显示应用工作区弹窗 */
const appWorkspace = defineAsyncComponent(() => import('@/features/app-workspace/app-workspace.vue'));
const isShowAppWorkspace = ref(false);
const onAppWorkspaceClosed = () => {
  isShowAppWorkspace.value = false;
};

const onOpenMiddlePageWorkbench = (url: string) => {
  if (!url) {
    return;
  }

  location.href = url;
};

onMounted(() => {
  initData();
  setAppList();
});
</script>

<style lang="scss" scoped>
.workbench-app {
  &__root {
    width: 100vw;
    height: 100vh;
    background-color: #f5f7f9;
    position: relative;
  }

  &__content {
    position: absolute;
    left: 50%;
    top: 114px;
    transform: translateX(-50%);
    width: 420px;
    background: #ffffff;
    box-shadow: 0px 8px 26px 0px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    padding-bottom: 12px;
  }

  &__header {
    box-sizing: border-box;
    height: 97px;
    padding-top: 18px;
    padding-left: 24px;
    padding-right: 24px;
    position: relative;
    .title {
      height: 28px;
      margin-bottom: 16px;
      font-size: 20px;
      color: #0c0f17;
      line-height: 28px;
    }

    .tip-label {
      display: inline-block;
      height: 22px;
      font-size: 12px;
      color: #727e96;
      line-height: 22px;
    }

    .btn-create-app {
      cursor: pointer;
      position: absolute;
      right: 24px;
      top: 61px;
      width: 84px;
      height: 24px;
      border-radius: 2px;
      border: 1px solid #417ff9;
      font-size: 12px;
      color: #417ff9;
      line-height: 24px;
      text-align: center;
    }
  }

  &__body {
    .w-scroll-root {
      position: relative;
      height: 364px;
      padding: 0 24px;
      box-sizing: border-box;
    }
  }
}
</style>
